import { IconButton, Tooltip } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useEffect, useState } from "react";

export default function RefreshButton({
  onRefresh,
}: {
  onRefresh: () => void;
}) {
  const [disabled, setDisabled] = useState(false);
  const handleRefresh = () => {
    setDisabled(true);
    onRefresh();
  };

  useEffect(() => {
    if (!disabled) return;
    const timeout = setTimeout(
      () => {
        setDisabled(false);
      },
      1 * 60 * 1000, // disable for 1 minute
    );
    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeout);
  }, [disabled]);

  return (
    <Tooltip title="Refresh">
      <IconButton
        onClick={handleRefresh}
        size="small"
        color="primary"
        disabled={disabled}
      >
        <Refresh fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
